import {
  RECEIVE_NOTIFICATIONS,
  HIDE_NOTIFICATION,
  MARK_NOTIFICATION_READ,
  MARK_ALL_AS_READ,
  RECEIVE_PUSH_NOTIFICATION
} from './types';

export function receiveNotifications(notificationList) {
  return ({
    type:    RECEIVE_NOTIFICATIONS,
    payload: { notificationList }
  });
}

export function receivePushNotification(notification) {
  return ({
    type:    RECEIVE_PUSH_NOTIFICATION,
    payload: { notification }
  });
}

export function hideNotification(notification) {
  return (dispatch, getState, notificationAPI) => {
    notificationAPI.update(notification.id, { active: false })
      .catch(() => {});
    dispatch({
      type:    HIDE_NOTIFICATION,
      payload: { id: notification.id }
    });
  };
}

export function markNotificationRead(notification) {
  return (dispatch, getState, notificationAPI) => {
    if (notification.unread) {
      notificationAPI.update(notification.id, { unread: false })
        .catch(() => {});
      dispatch({
        type:    MARK_NOTIFICATION_READ,
        payload: { id: notification.id }
      });
    }
  };
}

export function markAllAsRead() {
  return (dispatch, getState, notificationAPI) => {
    if (getState().unreadCount > 0) {
      notificationAPI.markAllAsRead()
        .catch(() => {});
      dispatch({
        type: MARK_ALL_AS_READ
      });
    }
  };
}

export function fetchNotifications() {
  return (dispatch, _, notificationAPI) => {
    notificationAPI.fetch()
      .then((response) => {
        dispatch(receiveNotifications(response.notificationList));
      }).catch(() => {});
  };
}
